<template>
  <div>
      <!-- breadcrumb area start -->
      <div class="breadcrumb-area">
<!--        <div class="container">-->
          <div class="row">
            <div class="col-md-12">
              <ol class="breadcrumb font-class">
                <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
                <li><a href="/#/center" v-on:click="sendMsg">核心业务</a></li>
                <li><a href="/#/bridge" v-on:click="sendMsg">桥梁振动监测</a></li>
                <li class="active">模态测试</li>
              </ol>
            </div>
          </div>
<!--        </div>-->
      </div>
      <!-- breadcrumb area end -->

      <!-- contact information start -->
      <div class="contant-information pt-20">
<!--        <div class="container">-->
          <div class="row">
            <div class="center_column col-xs-12 col-sm-12">
              <div class="rte">
                <h1 style="text-align:center;font-size: 20px">模态测试</h1>
                <hr>
                <p class="titleP">模态测试的重要性</p>
                <p>模态和振型测试属于动载试验，即测试桥梁的动力特性，包括频率振动和阻尼。
                  自振频率可以在一定程度上反映桥梁的刚度，同时获知实测自振频率后可以避免在营运过程中出现共振等不利情况。
                  模态参数的改变往往预示着结构上的变化，同时要避免桥梁的共振频率落入环境激励的范围内。
                  所以做模态测试检测桥梁固有频率、振型等可以提前发现缺陷避免事故。
                </p>
                <p class="titleP">模态测试的步骤</p>
                <ul style="color: black">
                  <li>桥梁模态实验的步骤是：</li>
                  <li>1、确定分析的方法</li>
                  <li>2、测点的选取、传感器的布置</li>
                  <li>3、仪器连接</li>
                  <li>4、示波</li>
                  <li>5、输入标定值</li>
                  <li>6、采样</li>
                  <li>7、模态分析</li>
                </ul>
                <p class="titleP">模态测试的仪器设备</p>
                <p>传感器选择：BY-S07型振动传感器、941B型振动传感器、991B振动传感器</p>

                <p>BY-S07型振动传感器、941B型振动传感器、991B振动传感器型振动传感器三种传感器具有优异的低频性能，
                  具有宽频带，高分辨率、大动态范围、抗冲击性能好的特点，其中BY-S07型振动传感器的防护等级达到IP67等级，
                  特别适用于长期健康监测。</p>

                <p>数据采集仪选择：D1000型数据采集仪、D3000型动态数据采集仪</p>

                <p>D1000型数据采集仪每通道内置独立的24bitADC，保证每通道最高以128kHz的采样率同步采样，
                  内置程控放大和滤波器，可完成信号的高速采集。采集仪可多台级联，
                  可支持8台采集仪128个采集通道同步采样。D1000型采集仪支持电压/IEPE信号输入；
                  采集软件可对数据进行时域分析、频谱分析、索力分析、频响函数分析、冲击系数、
                  模态分析得到峰峰值、有效值、自振频率、阻尼、振型等。 D1000型数据采集仪连接方式为电脑、
                  网线、采集仪，适用于检测。</p>
                <p>D3000型动态数据采集仪采用独立24bitADC并行同步采集，动态范围可达120db以上，
                  设备可级联扩展至128通道，采用直流适配器15V供电，也支持外接直流电池（蓄电池）供电，
                  有外部供电时时使用外部供电，并给内置电池供电，无外部供电时，自动切换至内置电池供电，
                  内置TF储存卡，在自然灾害来临（断电/断网），仪器仍正常工作，数据储存至TF卡中，
                  保证数据采集的连续性。采集仪开放底层协议，可使用C语言、Python语言等进行对接，
                  还可对接用户的监测平台。因此，D3000型动态数据采集仪适用于长期健康监测。
                  数据的输出格式可为txt、Excel等，可以对接国内外知名分析软件。</p>
                <p class="titleP">模态实验流程图</p>
                <img src="../../../assets/center/m1.png" alt="">
                <p class="titleP">模态测试的案例</p>
                <p>某桥梁模态测试现场图</p>
                <img src="../../../assets/center/m2.png" alt="">
              </div>
            </div>
          </div>
<!--        </div>-->
      </div>
      <!-- contact information end -->
    </div>
</template>

<script>
import {getContactDetail} from '../../../utils/api'

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
    this.getContactDetail()
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    async getContactDetail () {
      let contactData01 = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: this.render(contactData01.address_zh),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_zh)
        }
      } else {
        this.contactData = {
          address: this.render(contactData01.address_en),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_en)
        }
      }
      // console.log(this.contactData)
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>
<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    font-family: 宋体;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .rte img{
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: normal;
    color: #000;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/center/bridge/bridge-modal.vue